import axiosInstance from "../api";
import {
  GET_MINE_POSTS,
  GET_MINE_UMBRELLA_POSTS,
  GET_MYOREDR_UMBRELLA_PROJECT,
  GET_UMBRELLA_POSTS,
  GET_UMBRELLA_POSTS_BY_ID,
  GET_UMBRELLA_POSTS_LIST_BY_ID,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getUmbrellaPosts = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type ? type : ""}`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_UMBRELLA_POSTS,
        umbrellapostlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineUmbrallaPosts = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type}&is_mine=1&is_ambrella=1`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_UMBRELLA_POSTS,
        umbrellapostlistmine: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getUmbrallaPostsById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/id?id=${id}&is_ambrella=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_UMBRELLA_POSTS_BY_ID,
        umbrallapostbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineUmbrallaByProjectID = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?is_mine=1&parent_id=${id}`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_UMBRELLA_POSTS_LIST_BY_ID,
        umbrellapostlistbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMyOrderUmbrellaProjectList =
  (type, pagenumber, size, status) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type}&is_ambrella=1&is_mine=1&index=${pagenumber}&size=${size}&status=${status}`,
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_MYOREDR_UMBRELLA_PROJECT,
          myorderumbrellaprojectlist: response?.data,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };
